export default function Services() {
  const services = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura',
      description: 'Pintura interior y exterior con acabados profesionales. Preparación de superficies, imprimación y aplicación de pintura de alta calidad para resultados duraderos.',
      image: 'https://public.readdy.ai/ai/img_res/4677bf73ba6f9d1b0d4a5cb0d04156cf.jpg'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electricidad',
      description: 'Instalaciones eléctricas completas, reparaciones y mantenimiento. Cuadros eléctricos, iluminación, enchufes y sistemas de seguridad eléctrica certificados.',
      image: 'https://readdy.ai/api/search-image?query=electrician%20working%20on%20electrical%20panel%20with%20professional%20tools%20and%20wiring%20showing%20modern%20electrical%20installation%20with%20safety%20equipment%20and%20organized%20cables%20in%20clean%20workspace%20with%20proper%20lighting&width=600&height=400&seq=service-electricity&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'Fontanería',
      description: 'Instalación y reparación de sistemas de agua, desagües y calefacción. Detección de fugas, cambio de tuberías y mantenimiento de instalaciones sanitarias.',
      image: 'https://readdy.ai/api/search-image?query=plumber%20installing%20modern%20pipes%20and%20faucets%20with%20professional%20tools%20showing%20clean%20plumbing%20work%20with%20copper%20and%20PVC%20pipes%20in%20organized%20workspace%20demonstrating%20quality%20installation%20techniques&width=600&height=400&seq=service-plumbing&orientation=landscape'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Pladur',
      description: 'Instalación de tabiques, techos y trasdosados de pladur. Creación de espacios, aislamiento térmico y acústico con acabados perfectos listos para pintar.',
      image: 'https://readdy.ai/api/search-image?query=construction%20worker%20installing%20drywall%20panels%20on%20wall%20frame%20showing%20professional%20installation%20technique%20with%20tools%20and%20materials%20in%20clean%20organized%20workspace%20with%20proper%20lighting%20and%20safety%20equipment&width=600&height=400&seq=service-drywall&orientation=landscape'
    },
    {
      icon: 'ri-shield-line',
      title: 'Impermeabilizaciones',
      description: 'Protección de techos, terrazas y fachadas contra filtraciones. Aplicación de membranas impermeabilizantes y sellados para garantizar estanqueidad total.',
      image: 'https://readdy.ai/api/search-image?query=worker%20applying%20waterproofing%20membrane%20on%20roof%20terrace%20with%20professional%20equipment%20showing%20protective%20coating%20application%20in%20sunny%20weather%20with%20tools%20and%20materials%20demonstrating%20quality%20waterproofing%20work&width=600&height=400&seq=service-waterproofing&orientation=landscape'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Lavado',
      description: 'Limpieza profesional de fachadas, suelos y superficies. Lavado a presión para eliminar suciedad, moho y manchas, dejando las superficies como nuevas.',
      image: 'https://readdy.ai/api/search-image?query=professional%20pressure%20washing%20cleaning%20building%20facade%20with%20high%20pressure%20water%20equipment%20showing%20clean%20results%20and%20professional%20technique%20with%20safety%20gear%20in%20bright%20daylight%20demonstrating%20thorough%20cleaning%20service&width=600&height=400&seq=service-washing&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Mortero',
      description: 'Aplicación de mortero para revestimientos, reparaciones y nivelación. Preparación de superficies y acabados resistentes para construcción y reformas.',
      image: 'https://readdy.ai/api/search-image?query=construction%20worker%20applying%20mortar%20to%20wall%20with%20trowel%20showing%20smooth%20application%20technique%20with%20mixing%20bucket%20and%20tools%20in%20organized%20workspace%20demonstrating%20professional%20masonry%20work%20with%20quality%20materials&width=600&height=400&seq=service-mortar&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Yeso',
      description: 'Enlucidos y revestimientos de yeso para paredes y techos. Alisados perfectos, reparación de grietas y preparación de superficies para acabados finales.',
      image: 'https://readdy.ai/api/search-image?query=plasterer%20smoothing%20plaster%20on%20wall%20with%20professional%20tools%20showing%20perfect%20finish%20technique%20with%20hawk%20and%20trowel%20in%20clean%20workspace%20demonstrating%20quality%20plastering%20craftsmanship%20with%20smooth%20surface%20results&width=600&height=400&seq=service-plaster&orientation=landscape'
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Nuestros <strong className="text-amber-500">Servicios</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ofrecemos una amplia gama de servicios de <strong>construcción en Lanzarote</strong> con la más alta calidad y profesionalismo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-base text-gray-700 mb-6">
            ¿Necesitas un servicio específico? Contáctanos para un presupuesto personalizado
          </p>
          <a href="mailto:m.construesfuerzo@gmail.com?subject=Solicitud de Presupuesto&body=Hola, me gustaría solicitar un presupuesto para:" className="inline-block bg-amber-500 text-white px-8 py-3 rounded-lg text-base font-bold hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer">
            Solicitar Presupuesto
          </a>
        </div>
      </div>
    </section>
  );
}
